<template>
  <div class="wh100">
    <div class="tab-box">
      <div class="tab-buttons">
        <h3
          class="tab-button"
          :class="{'cur':curPanel==0}"
          @click="curPanel=0"
        >{{titles[0]?titles[0]:''}}</h3>
        <h3
          class="tab-button"
          :class="{'cur':curPanel==1}"
          @click="curPanel=1"
        >{{titles[1]?titles[1]:''}}</h3>
        <h3
          class="tab-button"
          :class="{'cur':curPanel==2}"
          @click="curPanel=2"
        >{{titles[2]?titles[2]:''}}</h3>
      </div>
      <div class="tabs">
        <div class="tabs-item wh100" v-show="curPanel==0">
          <slot name="content1"></slot>
        </div>
        <div class="tabs-item wh100" v-show="curPanel==1">
          <slot name="content2"></slot>
        </div>
        <div class="tabs-item wh100" v-show="curPanel==2">
          <slot name="content3"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    titles: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      curPanel: 0,
    };
  },
  methods:{
    setCurPanel(index){
      this.curPanel=index;
    }
  }
};
</script>
<style lang="less" scoped>
ul,
li,
span,
p,
h1,
h2,
h3,
h4,
h5,
h6,
a,
dl,
dt,
dd,
input {
  padding: 0;
  margin: 0;
  list-style: none;
  text-decoration: none;
  font-weight: normal;
  font-style: normal;
  font-family: "Microsoft yahei";
}
.tab-box {
  width: 100%;
  height: 100%;
  background: rgba(79, 79, 79, 0.25);
  box-sizing: content-box;
}

.tab-buttons {
  width: 100%;
  height: 2.1vw;
  display: flex;
  justify-content: space-between;
}
.tab-buttons .tab-button {
  width: 33%;
  float: left;
  height: 2.1vw;
  text-align: center;
  font-size: 0.9vw;
  color: #93a7d8;
  font-weight: 100;
  line-height: 2.1vw;
  position: relative;
  cursor: pointer;
  background: url(../../../assets/map/tab_2.png) no-repeat;
  background-size: 100% 100%;
}
.tab-buttons .tab-button.cur {
  background: url(../../../assets/map/tab_1.png) no-repeat;
  background-size: 100% 100%;
  color: #00eaff;
}
.tab-buttons .tab-button.cur:after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  width: 30%;
  height: 3px;
  background-color: #00eaff;
  margin: 0 auto;
}
.tabs {
  width: 100%;
  height: calc(100% - 2.1vw);
}
.tabs-item {
  padding: 5px;
  box-sizing: border-box;
}
</style>